export const programImages: { [key: string]: string } = {
  '1': 'https://www.bgv.co.kr/sm/upload/files/kor_popup_f82b0b9262366f2b5031a517d5e8c951.png',
  '2': 'https://www.bgv.co.kr/sm/upload/files/kor_popup_b84f920baedfde31bfead5579d4dde93.jpg',
  '3': 'https://www.bgv.co.kr/sm/upload/files/kor_popup_883ecca1cbc35ac2b2fa6e6e236f43a2.jpg',
  '4': 'https://www.bgv.co.kr/sm/upload/files/kor_popup_b51ea0d774cbbae0041e6428889eebc5.png',
  '5': 'https://www.bgv.co.kr/sm/upload/files/kor_popup_fca9010b5af34d7c10f1525183cfb348.png',
  '6': 'https://www.bgv.co.kr/sm/upload/files/kor_popup_f26da2ff03b2a850290237e749bf1ec9.png'
};